import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f4ee490"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "node" }
const _hoisted_2 = { class: "node-body-main" }
const _hoisted_3 = { class: "node-body-main-header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "option" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "node-body-main-content" }, [
  /*#__PURE__*/_createElementVNode("span", null, "并行任务（同时进行）")
], -1))
const _hoisted_7 = { class: "node-footer" }
const _hoisted_8 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_app_ellipsis = _resolveComponent("app-ellipsis")!
  const _component_CopyDocument = _resolveComponent("CopyDocument")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Close = _resolveComponent("Close")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_insert_button = _resolveComponent("insert-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "node-body",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('selected')))
    }, [
      (_ctx.level > 1)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "node-body-left",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('leftMove')), ["stop"]))
          }, [
            _createVNode(_component_el_icon, { size: "1em" }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowLeft)
              ]),
              _: 1
            })
          ], 512)), [
            [_vShow, _ctx.diagramMode !== 'viewer']
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_el_icon, { size: "1.6em" }, {
              default: _withCtx(() => [
                _createVNode(_component_Operation)
              ]),
              _: 1
            }),
            _createVNode(_component_app_ellipsis, {
              class: "name pl-1",
              "hover-tip": "",
              content: _ctx.config.name ? _ctx.config.name : '并行任务' + _ctx.level
            }, null, 8, ["content"])
          ]),
          _withDirectives(_createElementVNode("span", _hoisted_5, [
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "复制分支",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  size: "1.3em",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('copy')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CopyDocument)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_icon, {
              size: "1.3em",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('delNode')), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.diagramMode !== 'viewer']
          ])
        ]),
        _hoisted_6
      ]),
      (_ctx.level < _ctx.size)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "node-body-right",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('rightMove')), ["stop"]))
          }, [
            _createVNode(_component_el_icon, { size: "1em" }, {
              default: _withCtx(() => [
                _createVNode(_component_ArrowRight)
              ]),
              _: 1
            })
          ], 512)), [
            [_vShow, _ctx.diagramMode !== 'viewer']
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createVNode(_component_insert_button, {
          onInsertNode: _cache[5] || (_cache[5] = (type) => _ctx.$emit('insertNode', type))
        }, null, 512), [
          [_vShow, _ctx.diagramMode !== 'viewer']
        ])
      ])
    ])
  ]))
}